import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import LoadingSpinner from './LoadingSpinner';

export const ProtectedRoute = ({ adminOnly = false }) => {
  const { user, loading, isSuperAdmin, onboardingStatus } = useAuth();
  const location = useLocation();

  if (loading) {
    return <LoadingSpinner fullScreen label="Verifying session..." />;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (adminOnly && !isSuperAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  // Employee Onboarding Access Control Logic
  if (!isSuperAdmin && onboardingStatus) {
    const isCompleted = onboardingStatus.is_completed || onboardingStatus.progress_percentage === 100;
    const isOnboardingPath = location.pathname.startsWith('/onboarding');

    // If onboarding is NOT completed, force uncompleted employee into full-screen onboarding
    if (!isCompleted && !isOnboardingPath) {
      return <Navigate to="/onboarding" replace />;
    }

    // If onboarding IS completed, prevent re-entering onboarding
    if (isCompleted && isOnboardingPath) {
      return <Navigate to="/dashboard" replace />;
    }
  }

  return <Outlet />;
};

export default ProtectedRoute;
